import {FormCommit} from "@/store/module/enum/form-commit.enum";
import {
    FormGroupInterface,
    FormGroupRowInterface,
    SpreadsheetDataInterface
} from "@/store/module/interface/form.interface";
import slugify from 'slugify';
import {convertRangeToName} from "@/store/helper/helper";
import {cloneDeep} from 'lodash/fp';
const axios = require('axios').default;

export const form = {
    state: {
        groups: [],
        userInputs: {
            shipping: {
                value: 'non',
                required: false
            },
            name: {
                value: '',
                required: true,
            },
            phone: {
                value: '',
                required: true,
            },
            email: {
                value: '',
                required: true,
                email: true,
            },
            address: {
                value: '',
                required: false,
            },
            postcode: {
                value: '',
                required: false,
            },
            city: {
                value: '',
                required: false,
            },
            comment: {
                value: '',
                required: false,
            }
        },
        showSuccessModal: false
    },
    mutations: {
            [FormCommit.INITIALIZE_DATA] (state: any, payload: SpreadsheetDataInterface[]) {
            state.groups = payload.map(spreadsheetData => ({
                name: convertRangeToName(spreadsheetData.range),
                slug: slugify(convertRangeToName(spreadsheetData.range)),
                rows: spreadsheetData.values.map(singleRow => ({
                        ref: singleRow[0],
                        name: singleRow[1],
                        slug: slugify(singleRow[1].replace(/\*/g,'x'), {remove: /[*+~.()'"!:@]/g}),
                        price: singleRow[2],
                        commentary: singleRow.length > 2 ? singleRow[3] : '',
                        userValue: ''
                })) as FormGroupRowInterface[],
            })) as FormGroupInterface[];
        },
        [FormCommit.USER_SHIPPING] (state: any, payload: string) {
            state.userInputs.shipping.value = payload;
            state.userInputs.address.required = payload === 'oui';
            state.userInputs.postcode.required = payload === 'oui';
            state.userInputs.city.required = payload === 'oui';

        },
        [FormCommit.SUCCESS_MODAL_VISIBILITY] (state: any, payload: boolean) {
            state.showSuccessModal = payload;
        },
        [FormCommit.CLEAR_USER_GROUP_CHOICES] (state: any) {
            state.groups.forEach((formGroup: FormGroupInterface) => {
                if (formGroup.rows) {
                    formGroup.rows.forEach((row: FormGroupRowInterface) => row.userValue = '');
                }
            })
        }
    },
    actions: {
        fetchArticles(context: any, payload: any) {
            payload.gapiClient()
                .then((gapi: any) => {
                    gapi.client.sheets.spreadsheets.get({
                        spreadsheetId: payload.spreadsheet.catalogSpreadsheetId,
                        ranges: []
                    })
                        .then((response: any) => {
                            const ranges = response.result.sheets.map((sheet: { properties: { title: string } }) => convertRangeToName(sheet.properties.title));
                            gapi.client.sheets.spreadsheets.values.batchGet({
                                spreadsheetId: payload.spreadsheet.catalogSpreadsheetId,
                                ranges,
                            }).then((response: any) => {
                                context.commit(FormCommit.INITIALIZE_DATA, response.result.valueRanges);
                            });
                        });
                })
        },
        /**
         * When user selects the shipping option, apply required condition on addresses inputs
         * @param context
         * @param payload value of the user input
         */
        setUserShipping (context: any, payload: string) {
            context.commit(FormCommit.USER_SHIPPING, payload)
        },
        /**
         * Save user order
         */
        saveOrder (context: any, items: any) {
            return axios.post(process.env.VUE_APP_SERVICE_BACK_END_URL, {
                orderSpreadsheetId: context.getters.orderSpreadsheetId,
                ... items,
                ... context.getters.userPostDatas,
                ... context.getters.orderDatas(context.getters.currentSpreadsheetName)
            });
        },
        /**
         * Show success modal and reinitialize order items
         */
        showSuccessModal (context: any) {
            context.commit(FormCommit.SUCCESS_MODAL_VISIBILITY, true);
            context.commit(FormCommit.CLEAR_USER_GROUP_CHOICES, true);
        }
    },
    getters: {
        formGroups (state: any) {
            return state.groups;
        },
        selectedFormGroups: () => (dirtyFormGroups: FormGroupInterface[]) => {
            return cloneDeep(dirtyFormGroups).filter(formGroup => {
                if (!formGroup.rows) return false;
                return formGroup.rows.some(row => row.userValue !== '');
            }).map(formGroup => {
                if (!formGroup.rows) return formGroup;
                formGroup.rows = formGroup.rows.filter(row => row.userValue !== '');
                return formGroup;
            });
        },
        userInputs (state: any) {
            return state.userInputs;
        },
        userPostDatas (state: any) {
            const dataKeys = Object.keys(state.userInputs);
            const userPostDatas: {[key: string]: string} = {};

            dataKeys.forEach((key: string) => {
                userPostDatas[key] = state.userInputs[key].value;
            });

            return userPostDatas;
        },
        /**
         * Order data
         * @param state
         */
        orderDatas: () => (spreadsheetId: string) => {
            const orderDatas: {[key: string]: string} = {};
            const now = new Date();
            orderDatas['date'] = `${now.getDate()}/${now.getMonth() + 1}/${now.getFullYear()}`;
            orderDatas['hour'] = `${now.getHours()}:${now.getMinutes()}`;
            orderDatas['source'] = spreadsheetId.toString();

            return orderDatas
        },
        showSuccessModal(state: any) {
            return state.showSuccessModal;
        }
    }
}
